export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://playnoot-api-production-g2egg8e9drdngbfz.centralindia-01.azurewebsites.net";
